module.exports = require("minimist");


//////////////////
// WEBPACK FOOTER
// external "minimist"
// module id = 27
// module chunks = 0